import { UseFormReturn } from 'react-hook-form';

export enum FORM_RADIO_TYPES {
  PRODUCTS = 'PRODUCTS',
  CUSTOMIZATIONS = 'CUSTOMIZATIONS',
  DATE = 'DATE',
  TIME = 'TIME',
  DATE_UNTIL = 'DATE_UNTIL',
  DAYS = 'DAYS',
  START_DATE = 'START_DATE',
  FORMS = 'FORMS',
  BUS_USER_TIME = 'BUS_USER_TIME'
}

export const FORM_RADIO_COMPONENT_TYPES = {
  PRODUCTS: {
    title: 'formRadio.products.title',
    registerAs: 'products',
    requiredMessage: 'formRadio.products.requiredMessage',
    errorMessage: 'formRadio.products.errorMessage'
  },
  CUSTOMIZATIONS: {
    title: 'formRadio.customizations.title',
    registerAs: 'customizations',
    requiredMessage: 'formRadio.customizations.requiredMessage',
    errorMessage: 'formRadio.customizations.errorMessage'
  },
  DATE: {
    title: 'formRadio.date.title',
    registerAs: 'bookingDate',
    requiredMessage: 'formRadio.date.requiredMessage',
    errorMessage: 'formRadio.date.errorMessage'
  },
  TIME: {
    title: 'formRadio.time.title',
    registerAs: 'bookingTime',
    requiredMessage: 'formRadio.time.requiredMessage',
    errorMessage: 'formRadio.time.errorMessage'
  },
  DATE_UNTIL: {
    title: 'formRadio.dateUntil.title',
    registerAs: 'bookingDateUntil',
    requiredMessage: 'formRadio.dateUntil.requiredMessage',
    errorMessage: 'formRadio.dateUntil.errorMessage'
  },
  DAYS: {
    title: 'formRadio.days.title',
    registerAs: 'selectedDays',
    requiredMessage: 'formRadio.days.requiredMessage',
    errorMessage: 'formRadio.days.errorMessage'
  },
  START_DATE: {
    title: 'formRadio.startDate.title',
    registerAs: 'bookingStartDate',
    requiredMessage: 'formRadio.startDate.requiredMessage',
    errorMessage: 'formRadio.startDate.errorMessage'
  },
  FORMS: {
    title: 'formRadio.forms.title',
    registerAs: 'forms',
    requiredMessage: 'formRadio.forms.requiredMessage',
    errorMessage: 'formRadio.forms.errorMessage'
  },
  BUS_USER_TIME: {
    title: 'formRadio.busUserTime.title',
    registerAs: 'busUserTime',
    requiredMessage: 'formRadio.busUserTime.requiredMessage',
    errorMessage: 'formRadio.busUserTime.errorMessage'
  }
} as const;

export type FormDateAndTime = UseFormReturn<{
  [x: string]: (string | string[] | undefined)[] | (readonly ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'] | undefined)[];
  selectedDays: (readonly ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'] | undefined)[];
  bookingTime: (string | undefined)[];
  busUserTime: (string | undefined)[];
}>;
